import { Directive, ElementRef, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';

/**
 * Entrada de los títulos de sección al hacer scroll: la misma transición que
 * el título de "Sobre mí" (aboutme). El elemento aparece con un desvanecido y
 * un leve desplazamiento horizontal cuando entra en pantalla, y se rearma al
 * salir para repetir el efecto en la siguiente visita.
 *
 * Solo añade y quita clases; los estilos viven en `styles.css` (`.reveal-on-scroll`).
 */
@Directive({ selector: '[appRevealOnScroll]' })
export class RevealOnScrollDirective implements OnInit, OnDestroy {

  private observer?: IntersectionObserver;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private zone: NgZone,
  ) { }

  ngOnInit(): void {
    const element = this.el.nativeElement;
    this.renderer.addClass(element, 'reveal-on-scroll');

    // Sin IntersectionObserver el título se muestra tal cual, sin animación.
    if (typeof IntersectionObserver === 'undefined') {
      this.renderer.addClass(element, 'is-revealed');
      return;
    }

    // Fuera de la zona de Angular: solo cambia una clase, no hace falta detección de cambios.
    this.zone.runOutsideAngular(() => {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.renderer.addClass(element, 'is-revealed');
          } else {
            this.renderer.removeClass(element, 'is-revealed');
          }
        });
      }, { threshold: 0.2 });

      this.observer.observe(element);
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
